import { FormTemplate, useFormTemplateQuery } from 'graphql-common';
import getFormTemplateValuesFromQueryData from 'routes/FormTemplate/utils/getFormTemplateValuesFromQueryData';
import { FormTemplateMode } from 'routes/FormTemplate/enums';
import { Values } from '@lib/interfaces/form';
import removeIdFields from '@lib/utils/removeIdsFromObject';

type Args = {
  id: string;
  viewMode: FormTemplateMode;
};

export default function useFormTemplateQueryHook(args: Args) {
  const { id, viewMode } = args;

  const query = useFormTemplateQuery({
    fetchPolicy: 'network-only',
    skip: !id,
    variables: { id },
  });

  const { refetch, error, loading, data: queryData, previousData } = query;
  const data = queryData || previousData;
  const firstLoading = loading && queryData === undefined;
  const formTemplateQueryData = data?.data as FormTemplate;
  const formTemplateData: Values =
    formTemplateQueryData && viewMode === FormTemplateMode.Duplicate
      ? removeIdFields(
          getFormTemplateValuesFromQueryData({
            formTemplateData: formTemplateQueryData,
          }),
          ['attachmentsAttached'],
        )
      : getFormTemplateValuesFromQueryData({
          formTemplateData: formTemplateQueryData,
        });

  return {
    data: formTemplateData,
    loading,
    error,
    refetch,
    firstLoading,
  };
}
